import {combineReducers} from 'redux'
import {User} from '../api/user'
import {ICompanyTable} from './companyTable'
import userReducer from './user'
import companyTableReducer from './companyTable'
import orgReducer, {IOrg} from './org'
import courseReducer, {ICourse} from './course'

export interface IState {
  companyTable: ICompanyTable
  user: User
  org: IOrg
  course: ICourse
}

const rootReducer = combineReducers<IState>({
  companyTable: companyTableReducer,
  user: userReducer,
  org: orgReducer,
  course: courseReducer,
})

export default rootReducer
